import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { Provider, useSelector } from 'react-redux';
import { store } from './app/store.ts';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const ThemedApp = () => {
  const darkMode = useSelector((state: any) => state.theme.darkMode);

  const theme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <App /> */}
      <ThemedApp />
    </Provider>
  </React.StrictMode>
);